export default __webpack_public_path__ + "media/color/mda-7d21a9fb.svg";